import { IFormValues } from '../../popups/InterventionModal/form/types';

const createValues: IFormValues = {
  date: '',
  reason: '',
};

export default createValues;
